/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Principle_3_TitleInputs */

const en_about_principle_3_title = /** @type {(inputs: About_Principle_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Care after it launches.`)
};

const lv_about_principle_3_title = /** @type {(inputs: About_Principle_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rūpes pēc ieviešanas.`)
};

/**
* | output |
* | --- |
* | "Care after it launches." |
*
* @param {About_Principle_3_TitleInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const about_principle_3_title = /** @type {((inputs?: About_Principle_3_TitleInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Principle_3_TitleInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_about_principle_3_title(inputs)
	return en_about_principle_3_title(inputs)
});